import { ComponentBaseConfigModel } from '../component-base-config.model';

export interface DrawingComponentConfigModel extends ComponentBaseConfigModel {
  openOnStartup: boolean;
}
